import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportShipmentsPerformanceTypes } from "redux/reducers/Reports/reportShipmentsPerformance/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SHIPMENTS_PERFORMANCE_FILTERS } = reportShipmentsPerformanceTypes;

export const getReportShipmentsPerformanceAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/shipments-performance?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Rendimientos_Embarque_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingShipmentsPerformance'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingShipmentsPerformance'));
    }
  };
};

export const setReportShipmentsPerformanceFilters = (key = "", value) => ({
  type: SET_SHIPMENTS_PERFORMANCE_FILTERS,
  payload: { key, value }
});
